import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgPerson = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 0.933319C5.8645 0.933319 4.13333 2.66449 4.13333 4.79999C4.13333 6.56306 5.31332 8.05052 6.92664 8.51573C5.65301 8.67093 4.56061 9.12142 3.73767 9.93243C2.6903 10.9647 2.16002 12.5013 2.16002 14.5065C2.16002 14.7864 2.38687 15.0132 2.66669 15.0132C2.94652 15.0132 3.17335 14.7864 3.17335 14.5065C3.17335 12.6719 3.65638 11.4353 4.44897 10.6542C5.24305 9.87159 6.42852 9.46664 7.99994 9.46664C9.57138 9.46664 10.7569 9.87159 11.551 10.6542C12.3436 11.4353 12.8267 12.6719 12.8267 14.5065C12.8267 14.7864 13.0534 15.0132 13.3333 15.0132C13.6131 15.0133 13.84 14.7864 13.84 14.5067C13.84 12.5013 13.3097 10.9647 12.2623 9.93242C11.4394 9.12143 10.3469 8.67095 9.07333 8.51574C10.6866 8.05055 11.8667 6.56307 11.8667 4.79999C11.8667 2.66449 10.1355 0.933319 8 0.933319ZM5.14666 4.79999C5.14666 3.22414 6.42415 1.94665 8 1.94665C9.57585 1.94665 10.8533 3.22414 10.8533 4.79999C10.8533 6.37584 9.57585 7.65332 8 7.65332C6.42415 7.65332 5.14666 6.37584 5.14666 4.79999Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgPerson)
const IconSvgPerson = createIcon(ForwardRef, 'SvgPerson')
export default IconSvgPerson
